import { render, staticRenderFns } from "./Rolepermissions.vue?vue&type=template&id=e00cf3fa&scoped=true&"
import script from "./Rolepermissions.vue?vue&type=script&lang=js&"
export * from "./Rolepermissions.vue?vue&type=script&lang=js&"
import style0 from "./Rolepermissions.vue?vue&type=style&index=0&id=e00cf3fa&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e00cf3fa",
  null
  
)

export default component.exports